exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-pic[data-v-298a9323]{width:100%;background-color:#fff;border-bottom:1px solid #ddd;color:rgba(0,0,0,.56);padding-bottom:8px}.page--material .profile-pic[data-v-298a9323]{background-color:#f6f6f6}.profile-pic>img[data-v-298a9323]{display:block;max-width:100%}.page--material__background.page--white__background[data-v-298a9323]{background-color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-298a9323","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Menu.vue
// module id = 224
// module chunks = 0